import { Stack, StackProps } from "@mui/material";

export function Column(props: Omit<StackProps, "direction">) {
  return <Stack direction="column" {...props} />;
}
